module.exports = __webpack_public_path__ + "Frame394-1c60dbad.webp";